module.exports = __webpack_public_path__ + "static/img/img_4.f53bb26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/demo-blog/img_4.jpg
// module id = V19m
// module chunks = 0